"use strict";
/**
 * @module Services.TopicViews
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
/**
 * Read a topic view from the stream
 *
 * @param bis  the input stream
 * @return     the {@link TopicView} that was read
 */
function readTopicView(bis) {
    var name = Codec.readString(bis);
    var specification = Codec.readString(bis);
    var roles = new Set(Codec.readCollection(bis, Codec.readString));
    return {
        name: name,
        specification: specification,
        roles: roles
    };
}
exports.readTopicView = readTopicView;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-views/read-topic-view.js
// module id = 596
// module chunks = 1